import React, { useState } from "react";

import Tabs from "../../tabs";

const tabOptions = [
    {
        value: 1,
        text: "One",
    },
    {
        value: 2,
        text: "Two",
    },
    {
        value: 3,
        text: "Three",
    },
    {
        value: 4,
        text: "Four",
    },
];

const TabExample = () => {
    const [tabs, setTabs] = useState([
        { value: 1, text: "Panel 1", data: { content: "This is tab A" } },
        { value: 2, text: "Panel 2", data: { content: "This is tab B" } },
        { value: 3, text: "Panel 3", data: { content: "This is tab C" } },
    ]);
    const [dropdownTabs, setDropdownTabs] = useState([
        { value: 1, text: "Panel 1", data: { content: "This is tab A" } },
        { value: 2, text: "Panel 2", data: { content: "This is tab B" } },
        { value: 3, text: "Panel 3", data: { content: "This is tab C" } },
    ]);

    const addTab = (option) => {
        //const newTab = (option) ? option : { value: tabs.length+1, text: `Panel ${tabs.length+1}` };

        if (option) {
            setDropdownTabs([...dropdownTabs, { ...option, data: { content: "Another Tab" } }]);
        } else {
            setTabs([...tabs, { value: tabs.length + 1, text: `Panel ${tabs.length + 1}`, data: { content: "Another Tab" } }]);
        }
    };

    const removeTab = (index) => {
        const newTabs = [...tabs];
        newTabs.splice(index, 1);
        setTabs(newTabs);
    };

    const removeDropdownTab = (index) => {
        const newTabs = [...dropdownTabs];
        newTabs.splice(index, 1);
        setDropdownTabs(newTabs);
    };

    const tabHtml = tabs.map((t, i) => {
        return (
            <div key={`tabExample_${i}`} className="tab">
                {t.data.content}
            </div>
        );
    });

    const dropdownTabHtml = dropdownTabs.map((t, i) => {
        return (
            <div key={`tabExample_${i}`} className="tab">
                {t.data.content}
            </div>
        );
    });

    return (
        <div>
            <Tabs tabs={tabs} addTab={addTab} removeTab={removeTab}>
                {tabHtml}
            </Tabs>

            <h1>With Dropdown</h1>
            <Tabs tabs={dropdownTabs} addTab={addTab} removeTab={removeDropdownTab} tabOptions={tabOptions}>
                {dropdownTabHtml}
            </Tabs>
        </div>
    );
};

export default TabExample;
